import { render, staticRenderFns } from "./ForgotPasswordConfirmation.vue?vue&type=template&id=0b7d4dca"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports